import { render, staticRenderFns } from "./OfferCart.vue?vue&type=template&id=59590532&"
import script from "./OfferCart.vue?vue&type=script&lang=js&"
export * from "./OfferCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports